import React from "react";
import { DroneEntity, DroneStatusType } from "@src/core/features";
import { ArcDrone } from "@src/core/components";
import ToggleCollapseView from '@src/features/drone/pages/drones-page/components/toggle-collapse-view';
import { ArcStack } from "@src/core/ui";
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { EMPTY_STRING } from "@src/core/config";
import { setSelectedDrone, setHoveredDrone } from "@src/features/drone/redux/actions";
import { selectSelectedDrone } from "@src/features/drone/redux/selectors";
import { IdleSectionsProps } from "./types";
import { setMapLocation } from "@src/core/controllers";


export const IdleSections: React.FC<IdleSectionsProps> = (props) => {
  const { drones } = props;
  const dispatch = useDispatch();
  const [, setSearchParams] = useSearchParams();
  const selectedDrone = useSelector(selectSelectedDrone);
  const onToggleDrone = (drone: DroneEntity) => {
    dispatch(setHoveredDrone(null));
    
    if (selectedDrone?.serialNumber === drone.serialNumber) {
      setSearchParams({ droneSerial: EMPTY_STRING });
      dispatch(setSelectedDrone(null));
      return;
    }
    setSearchParams({ droneSerial: drone.serialNumber });
    dispatch(setMapLocation({
      latitude: Number(drone.latitude),
      longitude: Number(drone.longitude),
      address: drone.name,
    }));
  };

  const handleMouseEnter = (drone: DroneEntity) => {
    dispatch(setHoveredDrone(drone));
  };

  const handleMouseLeave = () => {
    dispatch(setHoveredDrone(null));
  };

  return (
    <ArcStack spacing={1}>        
      <ToggleCollapseView 
        count={drones.length}
        status={DroneStatusType.IDLE}>
        <ArcStack spacing={1} marginTop={3} marginBottom={2}>
          {drones.map((drone) => (
            <ArcDrone.primary 
              key={drone.id} 
              drone={drone}
              selected={selectedDrone?.serialNumber === drone.serialNumber}
              onClick={() => onToggleDrone(drone)}
              onMouseEnter={() => handleMouseEnter(drone)}
              onMouseLeave={handleMouseLeave}
            />   
          ))}
        </ArcStack>
      </ToggleCollapseView>        
    </ArcStack>
  );
};